export enum Path {
  Login = '/login',
  Events = '/admin/events',
  EventCreate = '/admin/event',
  EventEdit = '/admin/event/:id',
  EventPublic = '/event/:slug',
  EventPassword = '/event/:slug/admin',
}
